import upgreen from 'assets/icons/up-bold-green.svg';
import React, {Component} from 'react';
import './loan-deposit.style.scss';

export default class Deposit extends Component {
  render() {
    return (
      <div className='loan-container'>
        <div className='loan-left'>
          <div className='loan-target'>
            <div className='percent'>105%</div>
            <div className='desc'>Target</div>
          </div>
          <div className='loan-updown'>
            <div className='loan-period'>
              <img src={upgreen} alt='' width={24} height={24} />
              <div>Same Perriod</div>
            </div>
            <div className='loan-price'>
              <div className='price'>986 bil.</div>
              <div className='price-percent'>(3.5%)</div>
            </div>
          </div>
        </div>
        <div className='loan-right'>
          <div className='title'>DEPOSIT</div>
          <div>
            <span className='price'>43,000</span>
            <span className='unit'>bil. VND</span>
          </div>
          <div className='process'>
            <div className='process-bar' style={{width: '67%'}}></div>
          </div>
          <div className='process-des'>
            <div>
              <div className='process-price'>CASA: 20,000</div>
              <div className='process-percent'>(67%)</div>
            </div>
            <div>
              <div className='process-price text-end'>Term: 10,000</div>
              <div className='process-percent text-end'>(33%)</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/LoanAndDeposit/Deposit.js